import { lazy } from 'react';

// Lazy load demo components
export const DEMO_COMPONENTS = {
  DownloadDemo: lazy(() => import('./DownloadDemo')),
  SummarizeDemo: lazy(() => import('./SummarizeDemo')),
  NotesDemo: lazy(() => import('./NotesDemo')),
  ConvertVideoToPdfDemo: lazy(() => import('./ConvertVideoToPdfDemo')),
};

export type DemoComponentKey = keyof typeof DEMO_COMPONENTS;
